import * as constants from '../constants';
import * as msTeams from '@microsoft/teams-js';

import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser"
import TrackUserActivityApiService from './TrackUserActivityApiService'
import { useContext } from 'react';
import WindowContext from '../components/Shared/Context/Context';

const msalConfig = {
    auth: {
        clientId: constants.Auth.appId,
        authority: "https://login.windows.net/common",
        navigateToLoginRequestUrl: false,
        audience: constants.Auth.audience,
        redirectUri: `${window.location.origin}/${constants.Auth.signInEndPage}`,
        postLogoutRedirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
}

let teamsContext = null;
let isMsTeamsInitialized = false;

export const setTeamsContext = (context) => {
    teamsContext = context;
};

export const getTeamsContext = () => {
    return teamsContext;
};

export const initializeMsTeams = async () => {
    if (!isMsTeamsInitialized) {
        await msTeams.app.initialize();
        isMsTeamsInitialized = true;
    }
};


class AuthHelper_Local {
    static msalInstance = null;
    static async getMsalInstance() {
        if (!this.msalInstance) {
            this.msalInstance = new PublicClientApplication(msalConfig);
            await this.msalInstance.initialize();
            // Handle any pending redirect authentication
            try {
                const response = await this.msalInstance.handleRedirectPromise();
                if (response?.account) {
                    /*console.log("Redirect authentication successful:", response);*/
                    this.msalInstance.setActiveAccount(response.account);
                } else {
                    // Set an active account if already logged in
                    const accounts = this.msalInstance.getAllAccounts();
                    if (accounts.length > 0) {
                        this.msalInstance.setActiveAccount(accounts[0]);
                    }
                    else {
                        /*console.warn("No user account found. Initiating login...");*/
                        const loginResponse = await this.msalInstance.loginPopup({
                            scopes: Array.isArray(constants.Auth.scopes) ? constants.Auth.scopes : [constants.Auth.scopes]
                        });
                        this.msalInstance.setActiveAccount(loginResponse.account);
                    }
                }
            } catch (error) {
                console.error("Error handling redirect authentication:", error);
            }
        }
        return this.msalInstance;
    }

    static getDeviceType = () => {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "mobile";
        }
        return "desktop";
    };

    static IsUserLoggedIn() {
        return this.msalInstance.getActiveAccount() !== null;
    }

    static getAccount() {
        const msalInstance = this.msalInstance;
        if (!msalInstance) return null;

        const currentAccounts = msalInstance.getAllAccounts();
        if (currentAccounts === null) {
            console.error("No accounts detected!");
            return;
        } else if (currentAccounts.length > 1) {
            console.warn("Multiple accounts detected.");
            // Add choose account code here
            return currentAccounts[0];
        } else if (currentAccounts.length === 1) {
            return currentAccounts[0];
        }
    }

    static async getAccessToken() {
        const msalInstance = await this.getMsalInstance();

        const account = this.getAccount()
        // if (!account) {
        //     throw new Error("User not logged in");
        // }

        let tokenRequest = {
            account: account,
            scopes: Array.isArray(constants.Auth.scopes) ? constants.Auth.scopes : [constants.Auth.scopes]
        }

        try {
            const response = await msalInstance.acquireTokenSilent(tokenRequest);
            return response.accessToken;
        } catch (error) {
            console.warn("Silent token acquisition failed:", error);

            if (error instanceof InteractionRequiredAuthError) {
                const loginRequest = { scopes: tokenRequest.scopes };  // Define loginRequest
                const response = await msalInstance.acquireTokenPopup(loginRequest);
                return response.accessToken;  // Ensure the function always returns an access token
            } else {
                console.error("Unexpected token error:", error);
                throw error;  // Rethrow the error for better error handling
            }
        }
    }
}

class AuthHelper_Prod {
    static async getAccessToken(successCallbackFunction) {
        let context = getTeamsContext();
        if (!context) {
            // Wait until useTeams has set the context
            while (!context) {
                await new Promise((resolve) => setTimeout(resolve, 100)); // Wait 100ms
                context = getTeamsContext(); // Re-check after delay
            }
        }

        let token = window.localStorage.getItem("impersonationToken");
        if (window.localStorage.getItem("impersonationMode")) {
            successCallbackFunction(token);
        }
        else {
            msTeams.authentication.getAuthToken({
                successCallback: successCallbackFunction,
                failureCallback: function (error) { console.log("Failure: " + error); },
                resources: [constants.Auth.audience]
            });
        }
    }
}

export default class AuthHelper {
    static async getAccessToken(successCallbackFunction) {
        if (constants.isLocal) {
            if (window.localStorage.getItem("impersonationMode")) {
                var token = window.localStorage.getItem("impersonationToken")
                AuthHelper_Local.getAccessToken().then(function (response) {
                    successCallbackFunction(token);
                });
            }
            else {
                AuthHelper_Local.getAccessToken().then(function (response) {
                    if (response) {
                        successCallbackFunction(response);
                    }
                });
            }
        }
        else {
            AuthHelper_Prod.getAccessToken(successCallbackFunction);
        }
    }
}